import { translationDE } from './de'
import { TranslationMap } from './translationKeys'

export const resources = {
  de: {
    translation: translationDE,
  },
} satisfies Record<string, { translation: TranslationMap }>
